// extracted by mini-css-extract-plugin
export default {"header":"ContentHeader_header__0V8kj","title":"ContentHeader_title__m259r","downloadBtn":"ContentHeader_downloadBtn__iL0sN"};